import { Box } from "@mui/material";
import classNames from "classnames";
import { useAppSelector } from "../store/types";
import Content from "../features/content";
import ContentTabs from "../features/content/ContentTabs";
import styles from "./styles";
import useCss from "../hooks/useCss";
import {
  selectUserStatus,
  selectUserInstances,
  getConnectedInstanceSelector,
} from "../selectors/userInstanceSelector";

const ContentCrate = () => {
  const classes = useCss(styles);

  const status = useAppSelector(selectUserStatus);
  const instances = useAppSelector(selectUserInstances);
  const connectedInstance = useAppSelector(getConnectedInstanceSelector);
  return (
    <Box
      className={classNames(
        classes.rightContent,
        connectedInstance && classes.contentPanelActive,
      )}
    >
      {connectedInstance ? (
        <Content />
      ) : (
        (status === "success" || status === "rejected") &&
        instances.length === 0 && <ContentTabs />
      )}
    </Box>
  );
};

export default ContentCrate;
